export default function getParkingType({isMonthly, isAirport, isEvent}) {
    return isAirport
        ? 'airport'
        : isEvent
        ? 'event'
        : isMonthly
        ? 'monthly'
        : 'transient';
}
